import React, { useEffect, useState } from 'react';
import manualService from '../../services/manualService';

// Screenshots live beside the pages (images/<name>.png) and, like the pages,
// are only served after login, so they're fetched with the auth header and
// shown through an object URL. Anything else (e.g. an outside URL) shows its
// alt text instead.
const MANUAL_IMAGE_RE = /^(?:\.\.\/|\.\/)?(images\/[a-z0-9]+(?:-[a-z0-9]+)*\.(?:png|jpe?g|webp))$/;

// Every screenshot is captured from made-up fixture data
// (scripts/manual/screenshots), never from real clients.
export const SAMPLE_DATA_NOTE = 'Screenshot made with sample data. The names, accounts and figures are not real.';

const ManualImage = ({ src = '', alt = '' }) => {
  const match = MANUAL_IMAGE_RE.exec(src);
  const path = match ? match[1] : null;
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!path) return undefined;
    let objectUrl = null;
    let cancelled = false;
    manualService
      .getImage(path)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (!path || failed) {
    return alt ? <span className="text-muted fst-italic">[{alt}]</span> : null;
  }
  if (!url) {
    return <span className="manual-image-placeholder" role="img" aria-label={alt ? `Loading: ${alt}` : 'Loading screenshot'}></span>;
  }
  // Spans, not <figure>: Markdown puts images inside a paragraph.
  return (
    <span className="manual-figure">
      <img src={url} alt={alt} className="manual-screenshot" />
      <span className="manual-figure-note">{SAMPLE_DATA_NOTE}</span>
    </span>
  );
};

export default ManualImage;
